<div class="uploader-wrap">

  <input
    #fileInput
    type="file"
    [accept]="accept"
    [multiple]="multiple"
    (change)="onFilesSelected($event)"
    class="hidden-input"
  />

  <button type="button" class="btn-upload" (click)="fileInput.click()" [disabled]="uploading">
    <ng-container *ngIf="!uploading">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="16 16 12 12 8 16"/>
        <line x1="12" y1="12" x2="12" y2="21"/>
        <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
      </svg>
      {{ multiple ? 'Upload Files' : 'Upload File' }}
    </ng-container>
    <ng-container *ngIf="uploading">
      <span class="upload-spinner"></span>
      Uploading…
    </ng-container>
  </button>

  <p class="upload-error" *ngIf="error">{{ error }}</p>

</div>
